import { Controller } from 'stimulus';
const TomSelect = require('../../lib/tom_select');

export default class extends Controller {
  connect() {
    if (this.tomSelect) return;

    const options = {};

    if (this.element.dataset.url) {
      options.valueField = 'id';
      options.labelField = 'text';
      options.searchField = 'text';
      options.load = (query, callback) => {
        const url = new URL(this.element.dataset.url, window.location.origin);
        url.searchParams.set('term', query);
        fetch(url)
          .then(response => response.json())
          .then(json => { callback(json.results || json); })
          .catch(() => { callback(); });
      };
    }

    this.tomSelect = new TomSelect(this.element, options);
    this.element.classList.add('is-tom-select');

    this.tomSelect.on('change', () => {
      this.element.dispatchEvent(new Event('jChange'));
    });
  }

  disconnect() {
    if (this.tomSelect) {
      this.element.classList.remove('is-tom-select');
      this.tomSelect.destroy();
      this.tomSelect = null;
    }
  }
}
